// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"21bed4ba","201":"0a33ec6f","337":"0ef9674c","456":"13a33959","782":"763d6b18","870":"13a33959"}[chunkId] + ".chunk.css";
};